import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setSingleReview,
    getProductReviews,
    getProductReviewsCancelToken,
    resetProductReviewPage,
    resetProductReviews } from '../../../actions/products/reviews';
import ProductReviewList from './ProductReviewList';
import HighLow from '../../../assets/images/products/high_low.svg';
import LowHigh from '../../../assets/images/products/low_high.svg';
import Recent from '../../../assets/images/products/circular-wall-clock.svg';
import { getProductReviewFilters,
    getProductReviewFiltersCancelToken } from '../../../actions/products';
import NewFilterModal from '../../modals/filters/NewFilterModal';
import FilterIcon from '../../../assets/images/common/icons/filter.svg';
import SelectedFiltersIcon from '../../../assets/images/common/icons/filter-icon.svg';
import Loader from '../../misc/Loader';

function ProductReviewsContainer(props) {
    const { getProductReviews,
        token,
        setSingleReview,
        resetProductReviewPage,
        resetProductReviews,
        reviewCount } = props,
        [ratingHigh, setRatingHigh] = useState(false),
        [ratingLow, setRatingLow] = useState(false),
        [didMount, setDidMount] = useState(false), // hack for initial render
        [productId] = useState(props.productId),
        [reviews, setReviews] = useState(props.reviews),
        [filters, setFilters] = useState([]),
        [showFiltersModal, setShowFiltersModal] = useState(false),
        [selectedFilters, setSelectedFilters] = useState({});
    useEffect(() => {
        setReviews(props.reviews);
    }, [props.reviews]);

    useEffect(() => {
        getReviews();
        getProductReviewFilters(token, props.productId)
            .then(_ => {
                if (!!_.length) {
                    setFilters(_)
                }
            })
        return function cleanup() {
            if (getProductReviewsCancelToken) getProductReviewsCancelToken();
            if (getProductReviewFiltersCancelToken) getProductReviewFiltersCancelToken();
            resetProductReviews();
        }
    }, []);

    function getReviews(fromFirst = false, paramsToAdd) {
        if (fromFirst) resetProductReviewPage();
        let params = {
            ...(ratingHigh && {rating_high: 1}),
            ...(ratingLow && {rating_low: 1}),
            ...(paramsToAdd && paramsToAdd),
            ...(!!Object.keys(selectedFilters).length && selectedFilters),
            // ...(filtersToAdd && filtersToAdd),
            page: fromFirst ? 1 : reviews.page
        }
        getProductReviews(token, productId, params);
    }

    function updateRating(rating = null) {
        if (rating === 'high') {
            setRatingHigh(true);
            setRatingLow(false);
        } else if (rating === 'low') {
            setRatingHigh(false);
            setRatingLow(true);
        } else {
            setRatingHigh(false);
            setRatingLow(false);
        }
    }
    function handleReviewClick(review) {
        setSingleReview(review)
    }

    function addToFilters(key, filterValue) {
        if (selectedFilters[key]) {
            setSelectedFilters({
                ...selectedFilters,
                [key]: [...selectedFilters[key], filterValue]
            })
        } else {
            setSelectedFilters({
                ...selectedFilters,
                [key]: [filterValue]
            })
        }
    }

    function removeFromFilters(key, filterValue) {
        let currentSelectedFilters = { ...selectedFilters },
            lengthOfCurrentFilter = currentSelectedFilters[key].filter(_ => _ !== filterValue).length;
        if (!lengthOfCurrentFilter) {
            delete currentSelectedFilters[key];
        } else {
            currentSelectedFilters[key] = currentSelectedFilters[key].filter(_ => _ !== filterValue);
        }
        setSelectedFilters(currentSelectedFilters)
    }

    function applyFilters() {
        getReviews(true);
        setShowFiltersModal(false);
    }

    // Setting didMount to true upon mounting
    useEffect(() => setDidMount(true), []);

    // Updating only if did mount
    useEffect(() => { if (didMount) getReviews(true); }, [ratingHigh, ratingLow]);
    return (<>
        {
            reviews.hasFetched
            && <div className="product__reviews__sort">
                <div>
                    <button className={`product__reviews__sort__btn
                        ${(!ratingHigh && !ratingLow) ? 'product__reviews__sort__btn--active' : ''}`} onClick={() => updateRating()}>
                        <img src={Recent} alt="recent sort" />
                        RECENT
                    </button>
                    <button className={`product__reviews__sort__btn
                        ${ratingHigh ? 'product__reviews__sort__btn--active' : ''}`}onClick={() => updateRating('high')}>
                        <img src={HighLow} alt="high rating sort" />
                        HIGH TO LOW
                    </button>
                    <button className={`product__reviews__sort__btn
                        ${ratingLow ? 'product__reviews__sort__btn--active' : ''}`} onClick={() => updateRating('low')}>
                        <img src={LowHigh} alt="low rating sort" />
                        LOW TO HIGH
                    </button>
                </div>
                <div>
                    {
                        filters
                        && !!filters.length
                        && <button className={`product__reviews__sort__btn
                            ${!!Object.keys(selectedFilters).length ? 'product__reviews__sort__btn--active' : ''}`}
                            onClick={() => setShowFiltersModal(true)}>
                            <img src={!!Object.keys(selectedFilters).length ? SelectedFiltersIcon : FilterIcon} alt="filters" />
                            Filters
                        </button>
                    }
                </div>
            </div>
        }
        {
            reviews.fetching
            && reviews.page === 1
            ? <div className="product__reviews__loader"><Loader isCentered={true} withMargin={true} /></div>
            : !!reviews.all.length
            ? <>
             <ProductReviewList handleReviewClick={handleReviewClick}
                reviews={reviews.all} />
            {
                !reviews.hasEnd
                && reviews.hasFetched
                && reviewCount > 5
                && (reviewCount !== reviews.all.length)
                && <button
                    className="product__section product__reviews__load-more"
                    disabled={reviews.hasEnd || reviews.fetching}
                    onClick={() => getReviews()}>
                        {
                            reviews.fetching
                            ? 'Fetching Reviews...'
                            : 'Load More Reviews'
                        }
                </button> }
            </>
            : !reviews.fetching
            && reviews.page > 1
            ? <p className="product__reviews__loader">No reviews found.</p>
            : null
        }
        {
            showFiltersModal && <NewFilterModal filters={filters}
                selectedFilters={selectedFilters}
                addToFilters={addToFilters}
                handleApply={applyFilters}
                removeFromFilters={removeFromFilters}
                handleClearAll={() => setSelectedFilters({})}
                handleClose={() => setShowFiltersModal(false)} />
        }
    </>);
};

function mapStateToProps(state) {
    return {
        token: state.login.token,
        reviews: state.productReducer.reviews
    }
}

const mapDispatchToProps = {
    getProductReviews,
    resetProductReviews,
    resetProductReviewPage,
    setSingleReview
}

ProductReviewsContainer.propTypes = {
    productId: PropTypes.string.isRequired,
    reviewCount: PropTypes.number
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductReviewsContainer);
